import React from 'react';
import Map from '../Map/Map';
import CountryData from '../CountryData/CountryData';
import PolicyClassification from '../CountryData/PolicyClassification';
import FilterContainer from '../FilterContainer/FilterContainer';
import { processData, getSelectedCountry } from '../../utils/utils';
import { continents } from '../../data/continents';
import { filter, FilterQuery } from '../../utils/filters';
import { Country } from '../../types/Country';
import List from '../List/List';
import CustomButton from './CustomButton';
import { LatLngExpression } from 'leaflet';
import { useTranslation } from 'react-i18next';

const initialQuery: FilterQuery = {
  selectedCountry: '',
  riskClass: '',
  continent: '',
  coverPolicy: '',
};

const Container: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [state, setState] = React.useState<Array<Country>>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [changed, setChanged] = React.useState(false);
  const [query, setQuery] = React.useState<FilterQuery>(initialQuery);
  const [zoom, setZoom] = React.useState(3);
  const [showMap, setShowMap] = React.useState(true);
  const defaultCenter = [55,10] as LatLngExpression;
  const [center, setCenter] = React.useState<LatLngExpression>(defaultCenter);

  const selectedCountry = getSelectedCountry(state);

  React.useEffect(() => {
    const getData = async () => {
      const state = await processData();
      setNewState(state);
      setIsLoading(false);
    }
    getData();
  },[]);

  React.useEffect(() => {
    const newState = filter(state, query);
    setNewState(newState);
  }, [query]);

  React.useEffect(() => {
    const obj:any = continents.find(o => o.continentNameFin === query.continent || o.continentNameEng === query.continent);
    if(obj){
      setZoom(obj.continentZoom)
      setCenter(obj.center)
    }
  }, [query]);

  const setNewState = (newState: Country[]) => {
    setState(newState);
    setChanged(!changed);
  }

  const handleGoBack = () => {
    setQuery(initialQuery);
  }

  const handleMapSelectCountry = (country: Country | '') => {
    const newQuery = {...initialQuery};
    newQuery.selectedCountry = country;
    setQuery(newQuery);
  }

  return (
    <div>
      {isLoading ?
        <h1>{t('mapList:component.loading')}</h1> :
        <div>
          {showMap &&
          <div>
            <div className="button--container">
              <CustomButton component="map" showMap={showMap} setShowMap={setShowMap} />
              <CustomButton component="list" showMap={showMap} setShowMap={setShowMap} />
            </div>
            <PolicyClassification />
            <FilterContainer state={state} setState={setNewState} query={query} setQuery={setQuery} showMap={showMap} setCenter={setCenter}/>
            <Map changed={changed} state={state} selectCountry={handleMapSelectCountry} selectedCountry={selectedCountry} zoom={zoom} setZoom={setZoom} center={center} setCenter={setCenter}/>
            {selectedCountry &&
              <CountryData data={selectedCountry} goBack={handleGoBack}/>
            }
          </div>
          }
          {!showMap &&
          <div>
          <div className="button--container">
            <CustomButton component="map" showMap={showMap} setShowMap={setShowMap} />
            <CustomButton component="list" showMap={showMap} setShowMap={setShowMap} />
          </div>
          <PolicyClassification />
          <FilterContainer state={state} setState={setNewState} query={query} setQuery={setQuery} showMap={showMap} setCenter={setCenter}/>
          <List data={state} />
          {selectedCountry &&
              <CountryData data={selectedCountry} goBack={handleGoBack}/>
          }
        </div>
          }
        </div>
      }
    </div>
  );
}

export default Container;